module.exports = __webpack_public_path__ + "static/bg4-199e9ec14308832c6a8a49bd96c1fde6.jpg";